import { render, staticRenderFns } from "./WaveStage.vue?vue&type=template&id=5167043d"
import script from "./WaveStage.vue?vue&type=script&lang=js"
export * from "./WaveStage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports